import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import ErrorPage from "../pages/ErrorPage.vue";
import LoginPage from "../pages/Authentication/LoginPage.vue";
import DashboardIndex from "../pages/Dashboard/Index.vue";

import CreateUserPage from "../pages/Master/User/Create.vue"
import EditUserPage from "../pages/Master/User/Create.vue"
import ListUserPage from "../pages/Master/User/Index.vue"
import AdminProfilePage from "../pages/General/AdminProfile.vue"

import CreateMenuPage from "../pages/Master/Menu/Create.vue"
import EditMenuPage from "../pages/Master/Menu/Create.vue"
import ListMenuPage from "../pages/Master/Menu/Index.vue"

import CreateModulePage from "../pages/Master/Module/Create.vue"
import EditModulePage from "../pages/Master/Module/Create.vue"
import ListModulePage from "../pages/Master/Module/Index.vue"

import CreateRolePage from "../pages/Master/Role/Create.vue"
import EditRolePage from "../pages/Master/Role/Create.vue"
import ListRolePage from "../pages/Master/Role/Index.vue"
import AccessRolePage from "../pages/Master/Role/Access.vue"
import MenuRolePage from "../pages/Master/Role/Menu.vue"

import CreateRoleGroupPage from "../pages/Master/RoleGroup/Create.vue"
import EditRoleGroupPage from "../pages/Master/RoleGroup/Create.vue"
import ListRoleGroupPage from "../pages/Master/RoleGroup/Index.vue"

import CreateDepartmentPage from "../pages/Master/Department/Create.vue"
import EditDepartmentPage from "../pages/Master/Department/Create.vue"
import ListDepartmentPage from "../pages/Master/Department/Index.vue"

import CreateVesselPage from "../pages/Master/Vessel/Create.vue"
import EditVesselPage from "../pages/Master/Vessel/Create.vue"
import ListVesselPage from "../pages/Master/Vessel/Index.vue"

import CreatePositionPage from "../pages/Master/Position/Create.vue"
import EditPositionPage from "../pages/Master/Position/Create.vue"
import ListPositionPage from "../pages/Master/Position/Index.vue"

import CreatePortPage from "../pages/Master/Port/Create.vue"
import EditPortPage from "../pages/Master/Port/Create.vue"
import ListPortPage from "../pages/Master/Port/Index.vue"

import CreateCategoryStorePage from "../pages/Master/CategoryStore/Create.vue"
import EditCategoryStorePage from "../pages/Master/CategoryStore/Create.vue"
import ListCategoryStorePage from "../pages/Master/CategoryStore/Index.vue"

import CreateCategoryStoreGroupPage from "../pages/Master/CategoryStoreGroup/Create.vue"
import EditCategoryStoreGroupPage from "../pages/Master/CategoryStoreGroup/Create.vue"
import ListCategoryStoreGroupPage from "../pages/Master/CategoryStoreGroup/Index.vue"

import CreateVesselTypePage from "../pages/Master/VesselType/Create.vue"
import EditVesselTypePage from "../pages/Master/VesselType/Create.vue"
import ListVesselTypePage from "../pages/Master/VesselType/Index.vue"

import CreatePicPage from "../pages/Data/Pic/Create.vue"
import EditPicPage from "../pages/Data/Pic/Create.vue"
import ListPicPage from "../pages/Data/Pic/Index.vue"

import CreateItemPage from "../pages/Management/Item/Create.vue"
import EditItemPage from "../pages/Management/Item/Create.vue"
import ListItemPage from "../pages/Management/Item/Index.vue"

import CreateUnitPage from "../pages/Master/Unit/Create.vue"
import EditUnitPage from "../pages/Master/Unit/Create.vue"
import ListUnitPage from "../pages/Master/Unit/Index.vue"

import CreateVendorPage from "../pages/Master/Vendor/Create.vue"
import EditVendorPage from "../pages/Master/Vendor/Create.vue"
import ListVendorPage from "../pages/Master/Vendor/Index.vue"

import ListCatalogPage from "../pages/Management/Catalog/Index.vue"
import DetailCatalogPage from "../pages/Management/Catalog/Detail.vue"

import CreateVarianPage from "../pages/Management/Varian/Create.vue"
import EditVarianPage from "../pages/Management/Varian/Create.vue"
import ListVarianPage from "../pages/Management/Varian/Index.vue"

import CreateVesselClassPage from "../pages/Master/VesselClass/Create.vue"
import EditVesselClassPage from "../pages/Master/VesselClass/Create.vue"
import ListVesselClassPage from "../pages/Master/VesselClass/Index.vue"

import CreateUserPicPage from "../pages/Data/UserPic/Create.vue"
import EditUserPicPage from "../pages/Data/UserPic/Create.vue"
import ListUserPicPage from "../pages/Data/UserPic/Index.vue"

import CreateAccessPermissionPage from "../pages/Master/AccessPermission/Create.vue"
import EditAccessPermissionPage from "../pages/Master/AccessPermission/Create.vue"
import ListAccessPermissionPage from "../pages/Master/AccessPermission/Index.vue"

import CreateShipManagementCompanyPage from "../pages/Master/ShipManagementCompany/Create.vue"
import EditShipManagementCompanyPage from "../pages/Master/ShipManagementCompany/Create.vue"
import ListShipManagementCompanyPage from "../pages/Master/ShipManagementCompany/Index.vue"

import CreateShipOwnerCompanyPage from "../pages/Master/ShipOwnerCompany/Create.vue"
import EditShipOwnerCompanyPage from "../pages/Master/ShipOwnerCompany/Create.vue"
import ListShipOwnerCompanyPage from "../pages/Master/ShipOwnerCompany/Index.vue"

import CreateCascadingSchemePage from "../pages/Management/CascadingScheme/Create.vue"
import EditCascadingSchemePage from "../pages/Management/CascadingScheme/Create.vue"
import ListCascadingSchemePage from "../pages/Management/CascadingScheme/Index.vue"

import CreateRequisition from "../pages/Management/Requisition/Create.vue"
import EditRequisitionPage from "../pages/Management/Requisition/Create.vue"
import ListRequisitionPage from "../pages/Management/Requisition/Index.vue"
import ListApprovalRequisitionPage from "../pages/Management/Requisition/Approval.vue"
import ListIncomingRequisitionPage from "../pages/Management/Requisition/Incoming.vue"
import AddProductRequisition from "../pages/Management/Requisition/Add.vue"
import DetailRequisition from "../pages/Management/Requisition/Detail.vue"

import ListLogActivityPage from "../pages/Management/LogActivity/Index.vue"

import VesselItemEditPage from "../pages/Management/ItemVessel/Create.vue"
import VesselItemCreatePage from "../pages/Management/ItemVessel/Create.vue"
import VesselItemListPage from "../pages/Management/ItemVessel/Index.vue"

import DashboardItemGroupCategory from "../pages/Dashboard/ItemGroupCategoryDashboard.vue"

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "LoginPage",
    component: LoginPage,
  },
  {
    path: "/dashboard",
    name: "Dashboard General",
    component: DashboardIndex,
  },
  {
    path: "/dashboard/item-group-category/:code",
    name: "Dashboard Item Group Category",
    component: DashboardItemGroupCategory,
  },
  {
    path: "/master/user/create",
    name: "CreateUserPage",
    component: CreateUserPage,
  },
  {
    path: "/master/user",
    name: "ListUserPage",
    component: ListUserPage,
  },
  {
    path: "/master/user/:id",
    name: "EditUserPage",
    component: EditUserPage,
  },
  {
    path: "/master/menu/create",
    name: "CreateMenuPage",
    component: CreateMenuPage,
  },
  {
    path: "/master/menu",
    name: "ListMenuPage",
    component: ListMenuPage,
  },
  {
    path: "/master/menu/:id",
    name: "EditMenuPage",
    component: EditMenuPage,
  },
  {
    path: "/master/module/create",
    name: "CreateModulePage",
    component: CreateModulePage,
  },
  {
    path: "/master/module",
    name: "ListModulePage",
    component: ListModulePage,
  },
  {
    path: "/master/module/:id",
    name: "EditModulePage",
    component: EditModulePage,
  },
  {
    path: "/general/admin-profile/:id",
    name: "AdminProfilePage",
    component: AdminProfilePage,
  },
  {
    path: "/master/role/create",
    name: "CreateRolePage",
    component: CreateRolePage,
  },
  {
    path: "/master/role",
    name: "ListRolePage",
    component: ListRolePage,
  },
  {
    path: "/master/role/:id",
    name: "EditRolePage",
    component: EditRolePage,
  },
  {
    path: "/master/role/access/:id",
    name: "AccessRolePage",
    component: AccessRolePage,
  },
  {
    path: "/master/role/menu/:id",
    name: "MenuRolePage",
    component: MenuRolePage,
  },
  {
    path: "/master/role-group/create",
    name: "CreateRoleGroupPage",
    component: CreateRoleGroupPage,
  },
  {
    path: "/master/role-group",
    name: "ListRoleGroupPage",
    component: ListRoleGroupPage,
  },
  {
    path: "/master/role-group/:id",
    name: "EditRoleGroupPage",
    component: EditRoleGroupPage,
  },
  {
    path: "/master/department/create",
    name: "CreateDepartmentPage",
    component: CreateDepartmentPage,
  },
  {
    path: "/master/department",
    name: "ListDepartmentPage",
    component: ListDepartmentPage,
  },
  {
    path: "/master/department/:id",
    name: "EditDepartmentPage",
    component: EditDepartmentPage,
  },
  {
    path: "/master/vessel/create",
    name: "CreateVesselPage",
    component: CreateVesselPage,
  },
  {
    path: "/master/vessel",
    name: "ListVesselPage",
    component: ListVesselPage,
  },
  {
    path: "/master/vessel/:id",
    name: "EditVesselPage",
    component: EditVesselPage,
  },
  {
    path: "/master/vessel-type/create",
    name: "CreateVesselTypePage",
    component: CreateVesselTypePage,
  },
  {
    path: "/master/vessel-type",
    name: "ListVesselTypePage",
    component: ListVesselTypePage,
  },
  {
    path: "/master/vessel-type/:id",
    name: "EditVesselTypePage",
    component: EditVesselTypePage,
  },
  {
    path: "/master/vessel-class/create",
    name: "CreateVesselClassPage",
    component: CreateVesselClassPage,
  },
  {
    path: "/master/vessel-class",
    name: "ListVesselClassPage",
    component: ListVesselClassPage,
  },
  {
    path: "/master/vessel-class/:id",
    name: "EditVesselClassPage",
    component: EditVesselClassPage,
  },
  {
    path: "/master/position/create",
    name: "CreatePositionPage",
    component: CreatePositionPage,
  },
  {
    path: "/master/position",
    name: "ListPositionPage",
    component: ListPositionPage,
  },
  {
    path: "/master/position/:id",
    name: "EditPositionPage",
    component: EditPositionPage,
  },
  {
    path: "/master/ship-management-company/create",
    name: "CreateShipManagementCompanyPage",
    component: CreateShipManagementCompanyPage,
  },
  {
    path: "/master/ship-management-company",
    name: "ListShipManagementCompanyPage",
    component: ListShipManagementCompanyPage,
  },
  {
    path: "/master/ship-management-company/:id",
    name: "EditShipManagementCompanyPage",
    component: EditShipManagementCompanyPage,
  },
  {
    path: "/master/ship-owner-company/create",
    name: "CreateShipOwnerCompanyPage",
    component: CreateShipOwnerCompanyPage,
  },
  {
    path: "/master/ship-owner-company",
    name: "ListShipOwnerCompanyPage",
    component: ListShipOwnerCompanyPage,
  },
  {
    path: "/master/ship-owner-company/:id",
    name: "EditShipOwnerCompanyPage",
    component: EditShipOwnerCompanyPage,
  },
  {
    path: "/master/port/create",
    name: "CreatePortPage",
    component: CreatePortPage,
  },
  {
    path: "/master/port",
    name: "ListPortPage",
    component: ListPortPage,
  },
  {
    path: "/master/port/:id",
    name: "EditPortPage",
    component: EditPortPage,
  },
  {
    path: "/master/category-store/create",
    name: "CreateCategoryStorePage",
    component: CreateCategoryStorePage,
  },
  {
    path: "/master/category-store",
    name: "ListCategoryStorePage",
    component: ListCategoryStorePage,
  },
  {
    path: "/master/category-store/:id",
    name: "EditCategoryStorePage",
    component: EditCategoryStorePage,
  },
  {
    path: "/master/category-store-group/create",
    name: "CreateCategoryStoreGroupPage",
    component: CreateCategoryStoreGroupPage,
  },
  {
    path: "/master/category-store-group",
    name: "ListCategoryStoreGroupPage",
    component: ListCategoryStoreGroupPage,
  },
  {
    path: "/master/category-store-group/:id",
    name: "EditCategoryStoreGroupPage",
    component: EditCategoryStoreGroupPage,
  },
  {
    path: "/data/pic/create",
    name: "CreatePicPage",
    component: CreatePicPage,
  },
  {
    path: "/data/pic",
    name: "ListPicPage",
    component: ListPicPage,
  },
  {
    path: "/data/pic/:id",
    name: "EditPicPage",
    component: EditPicPage,
  },
  {
    path: "/management/item/create",
    name: "CreateItemPage",
    component: CreateItemPage,
  },
  {
    path: "/management/item",
    name: "ListItemPage",
    component: ListItemPage,
  },
  {
    path: "/management/item/:id",
    name: "EditItemPage",
    component: EditItemPage,
  },
  {
    path: "/management/cascading-scheme/create",
    name: "CreateCascadingSchemePage",
    component: CreateCascadingSchemePage,
  },
  {
    path: "/management/cascading-scheme",
    name: "ListCascadingSchemePage",
    component: ListCascadingSchemePage,
  },
  {
    path: "/management/cascading-scheme/:id",
    name: "EditCascadingSchemePage",
    component: EditCascadingSchemePage,
  },
  {
    path: "/management/catalog",
    name: "ListCatalogPage",
    component: ListCatalogPage,
  },
  {
    path: "/management/catalog/detail/:id",
    name: "DetailCatalogPage",
    component: DetailCatalogPage,
  },
  {
    path: "/master/unit/create",
    name: "CreateUnitPage",
    component: CreateUnitPage,
  },
  {
    path: "/master/unit",
    name: "ListUnitPage",
    component: ListUnitPage,
  },
  {
    path: "/master/unit/:id",
    name: "EditUnitPage",
    component: EditUnitPage,
  },
  {
    path: "/master/vendor/create",
    name: "CreateVendorPage",
    component: CreateVendorPage,
  },
  {
    path: "/master/vendor",
    name: "ListVendorPage",
    component: ListVendorPage,
  },
  {
    path: "/master/vendor/:id",
    name: "EditVendorPage",
    component: EditVendorPage,
  },
  {
    path: "/master/access-permission/create",
    name: "CreateAccessPermissionPage",
    component: CreateAccessPermissionPage,
  },
  {
    path: "/master/access-permission",
    name: "ListAccessPermissionPage",
    component: ListAccessPermissionPage,
  },
  {
    path: "/master/access-permission/:id",
    name: "EditAccessPermissionPage",
    component: EditAccessPermissionPage,
  },
  {
    path: "/management/varian/create/:id",
    name: "CreateVarianPage",
    component: CreateVarianPage,
  },
  {
    path: "/management/varian",
    name: "ListVarianPage",
    component: ListVarianPage,
  },
  {
    path: "/management/varian/:id",
    name: "EditVarianPage",
    component: EditVarianPage,
  },
  {
    path: "/management/requisition/create",
    name: "CreateRequisition",
    component: CreateRequisition,
    meta: { layout: 'BlankLayout' }
  },
  {
    path: "/management/requisition/add/:id",
    name: "AddProductRequisition",
    component: AddProductRequisition,
    meta: { layout: 'BlankLayout' }
  },
  {
    path: "/management/requisition",
    name: "ListRequisitionPage",
    component: ListRequisitionPage,
  },
  {
    path: "/management/requisition-approval",
    name: "ListApprovalRequisitionPage",
    component: ListApprovalRequisitionPage,
  },
  {
    path: "/management/requisition-incoming",
    name: "ListIncomingRequisitionPage",
    component: ListIncomingRequisitionPage,
  },
  {
    path: "/management/requisition/:id",
    name: "EditRequisitionPage",
    component: EditRequisitionPage,
    meta: { layout: 'BlankLayout' }
  },
  {
    path: "/management/requisition/detail/:id",
    name: "DetailRequisition",
    component: DetailRequisition,
    meta: { layout: 'BlankLayout' }
  },
  {
    path: "/data/user-pic/create",
    name: "CreateUserPicPage",
    component: CreateUserPicPage,
  },
  {
    path: "/data/user-pic",
    name: "ListUserPicPage",
    component: ListUserPicPage,
  },
  {
    path: "/data/user-pic/:id",
    name: "EditUserPicPage",
    component: EditUserPicPage,
  },
  {
    path: "/management/log-activity",
    name: "ListLogActivityPage",
    component: ListLogActivityPage,
  },
  {
    path: "/management/vessel-item",
    name: "VesselItemListPage",
    component: VesselItemListPage,
  },
    {
    path: "/management/vessel-item/:id",
    name: "VesselItemEditPage",
    component: VesselItemEditPage,
  },
  {
    path: "/management/vessel-item/create",
    name: "VesselItemCreatePage",
    component: VesselItemCreatePage,
  },

  { path: "/:pathMatch(.*)*", name: "ErrorPage", component: ErrorPage },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkExactActiveClass: "active",
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

export default router;
